export enum Role {
  centreAdmin = 'centreadmin',
  centreHead = 'centre-head',
  facilitator = 'learner',
  learner = 'facilitator',
  questAdmin = 'questadmin',
  superAdmin = 'super-admin',
}
